import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import SEO from '../components/SEO';

export default function MentionsLegales() {
  const { language } = useLanguage();
  return (
    <div className="min-h-screen pt-20 lg:pt-24" data-testid="legal-page">
      <SEO
        title="Mentions légales - AfriOne BD"
        description="Mentions légales d'AfriOne BD, épicerie africaine en ligne établie à Liège (BCE 1031.014.285)."
        canonical="https://afrionebd.eu/mentions-legales"
      />
      <section className="py-12 lg:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <span className="text-xs uppercase tracking-widest text-primary font-medium">Informations légales</span>
            <h1 className="text-3xl lg:text-4xl font-bold font-heading text-text_primary mt-2 mb-2 tracking-tight">
              Mentions légales
            </h1>

            {/* Document juridique : il fait foi en français. Une traduction
                de complaisance créerait une ambiguïté sur le texte applicable. */}
            {language === 'en' && (
              <p className="mb-6 p-4 border border-border bg-secondary/20 text-sm text-text_secondary">
                This legal notice is available in French only. The French version is the
                legally binding text. For any question, write to{' '}
                <a href="mailto:contact@afrionebd.eu" className="text-primary hover:underline">contact@afrionebd.eu</a>.
              </p>
            )}
            <p className="text-sm text-text_secondary mb-10">Dernière mise à jour : juillet 2026</p>

            <div className="space-y-8 text-text_secondary leading-relaxed">
              <div>
                <h2 className="text-xl font-bold text-text_primary mb-3">1. Éditeur du site</h2>
                <p>
                  Le présent site <strong>afrionebd.eu</strong> est édité par :
                </p>
                <ul className="mt-3 space-y-1">
                  <li><strong>AfriOne BD</strong></li>
                  <li>Entreprise individuelle (personne physique)</li>
                  <li>Rue Saint-Nicolas 227, 4000 Liège, Belgique</li>
                  <li>Numéro d'entreprise (BCE) : 1031.014.285</li>
                  <li>Numéro de TVA : BE1031014285</li>
                  <li>Email : <a href="mailto:contact@afrionebd.eu" className="text-primary hover:underline">contact@afrionebd.eu</a></li>
                  <li>Téléphone : 0465 71 01 17</li>
                </ul>
              </div>

              <div>
                <h2 className="text-xl font-bold text-text_primary mb-3">2. Directeur de la publication</h2>
                <p>
                  Le responsable de la publication est le gérant d'AfriOne BD, joignable à l'adresse
                  <a href="mailto:contact@afrionebd.eu" className="text-primary hover:underline"> contact@afrionebd.eu</a>.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-text_primary mb-3">3. Hébergement</h2>
                <p>
                  Le site est hébergé par <strong>OVH SAS</strong>, 2 rue Kellermann, 59100 Roubaix, France -
                  <a href="https://www.ovh.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline"> www.ovh.com</a>.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-text_primary mb-3">4. Propriété intellectuelle</h2>
                <p>
                  L'ensemble du contenu de ce site (textes, visuels, logo, structure) est la propriété
                  d'AfriOne BD ou de ses partenaires, sauf mention contraire. Toute reproduction ou
                  utilisation sans autorisation écrite préalable est interdite. Les images de produits
                  proviennent de nos fournisseurs et restent leur propriété.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-text_primary mb-3">5. Responsabilité</h2>
                <p>
                  AfriOne BD s'efforce d'assurer l'exactitude des informations diffusées sur le site
                  (descriptions et prix des produits, disponibilités). Des erreurs ou omissions peuvent
                  toutefois survenir ; elles n'engagent pas la responsabilité de l'éditeur. Les photographies
                  des produits sont non contractuelles.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-text_primary mb-3">6. Droit applicable</h2>
                <p>
                  Le présent site et son utilisation sont soumis au droit belge. En cas de litige, les
                  tribunaux de l'arrondissement judiciaire de Liège sont seuls compétents.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
